import { typedGql } from '@zeus/typedDocumentNode'
import { scalars } from '~/gql/utils/scalars'

const sessionFields = {
  id: true,
  name: true,
  startDate: true,
  endDate: true,
  enrolledLearners: true,
  pendingLearners: true,
} as const

/** Accueil back-office (#201) : les faits du jour, en une requête. */
export const GQL_BACK_OFFICE_HOME = typedGql('query', { scalars })({
  backOfficeHome: {
    firstName: true,
    timezone: true,
    completedToday: {
      sessionId: true,
      sessionName: true,
      moduleId: true,
      moduleTitle: true,
      learners: true,
    },
    startingSoon: sessionFields,
    endingSoon: sessionFields,
    overdue: sessionFields,
    overdueLearners: true,
    overdueSessions: true,
    neverStartedLearners: true,
  },
})
